export default {
    path: '',
    component: () => import(`@/page/distributor/component/noLogin-layout/1.0.1/index.vue`),
    children: [
        {
            path: '/distributor/aboutUs',
            name: 'distributor-aboutUs',
            component: () => import('./index.vue'),
            meta: {
                skip_check_token: true,
            }
        },
    ]
};
